import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { AuthService } from '../../services/auth.service';
import {
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { UserItemType } from '../../types/item-type.type';
import { UsernameValidator } from '../../validators/username.validator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { Role } from '../../models/role.model';

@Component({
  selector: 'app-modal-user-invitation',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIcon,
  ],
  templateUrl: './modal-user-invitation.component.html',
  styleUrl: './modal-user-invitation.component.css',
})
export class ModalUserInvitationComponent {
  public userTypes: UserItemType[] = [
    { value: 1, name: 'administrator', userCardName: 'admin' },
    { value: 0, name: 'Pracownik', userCardName: 'user' },
  ];

  // Dodać typ dla ról 
  public roles: Role[] = [];

  public selectedUserType = 1;

  public sendForm = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
      asyncValidators: [
        UsernameValidator.createValidator(
          this.usersService,
          this.authService,
          this.usersService.http
        ),
      ],
      updateOn: 'change',
    }),
    role: new FormControl(0, {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  constructor(
    public router: Router,
    readonly dialog: MatDialog,
    public usersService: UsersService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ModalUserInvitationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('Roles:', data.roles);
    this.roles = data.roles;
  }

  private snackbarConfig: MatSnackBarConfig = {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 5000,
    };

  onSubmit() {
    if (this.sendForm.valid) {
      const { email, role } = this.sendForm.getRawValue();

      this.usersService.sendInvitation(email, role)
      .subscribe({
        next: (res:any) => {
          this.snackBar.open('Wysłano zaproszenie do: ' + email, 'OK', this.snackbarConfig);
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          // console.log(error);          
          switch(err.status) {
            case 403:
              this.snackBar.open('Brak uprawnień', 'OK', this.snackbarConfig);
              break;

            case 422: 
              this.snackBar.open('Błędy walidacji', 'OK', this.snackbarConfig);
              break;

            case 409:
              this.snackBar.open('Email już ma aktywne zaproszenie lub konto z takim emailem już istnieje', 'OK', this.snackbarConfig);
              break;

            default:
              this.snackBar.open('Coś poszło nie tak', 'OK', this.snackbarConfig);
              console.error(err);
          }
        }
      });
    }
  }

  resetForm() {
    this.sendForm.reset();
  }
}
